import { useEffect, useMemo, useState } from "react";
import { apiGet } from "./api";

// Shared by the Monitoring sub-pages (USB, URL Tracker, File Monitor, File
// Uploads) to power their "Team" filter dropdown. /api/departments is already
// scoped server-side (manager/employee only get their own team(s) back), so
// this never needs role checks of its own — it just renders whatever the API
// returns.
export function useTeamFilter() {
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        let active = true;
        apiGet("/api/departments")
            .then((res) => res.json())
            .then((data) => {
                if (active && data?.success) setDepartments(data.departments || []);
            })
            .catch((err) => console.error("Failed to fetch departments for team filter:", err));
        return () => { active = false; };
    }, []);

    // agentId -> department name, built once per departments fetch.
    const agentTeamMap = useMemo(() => {
        const map = new Map();
        departments.forEach((dept) => {
            (dept.agents || []).forEach((agentId) => map.set(agentId, dept.name));
        });
        return map;
    }, [departments]);

    const getTeamName = (agentId) => agentTeamMap.get(agentId) || "Unassigned";

    return { departments, getTeamName };
}
